export default {
  title: {
    en: 'Selected for you',
  },
  seasonsTitle: {
    en: 'Trending this {season}',
  },
  winter: {
    en: 'Winter',
  },
  spring: {
    en: 'Spring',
  },
  summer: {
    en: 'Summer',
  },
  fall: {
    en: 'Fall',
  },
}
